export const setUser = (user) => ({
    type: 'SET_USER',
    data: { user: user }
})

// module.exports = {
//     setUser: setUser,
// }